declare namespace $ {

	export class $giper_web_frame extends $mol_frame {
		uri( ): string
		query( ): string
	}
	
}

//# sourceMappingURL=frame.view.tree.d.ts.map